import React, { Component } from 'react';
import AuthService from '../../services/AuthService.js';

export class CambiarClaveContentPanel extends Component {
    constructor(props) {
        super(props);

        let usuarioId = -1;
        let usuarioTipo = "usuario";
        if (AuthService.getToken().auxId) {
            usuarioId = AuthService.getToken().auxId;
            usuarioTipo = "empleado";
        } else if (AuthService.getToken().id) {
            usuarioId = AuthService.getToken().id;
            usuarioTipo = "usuario";
        }

        this.state = {
            usuarioId: usuarioId,
            usuarioTipo: usuarioTipo
        };
    }
    render() {
        return (
            <div>
                <input name="UsuarioId" type="hidden" value={this.state.usuarioId} />
                <input name="UsuarioTipo" type="hidden" value={this.state.usuarioTipo} />
                <div class="form-group">
                    <div className="form-row">
                        <label class="col-md-2">Contraseña actual</label>
                        <input name="Clave" type="password" className="form-control form-control-sm col-md-4" />
                    </div>
                </div>
                <div class="form-group">
                    <div className="form-row">
                        <label class="col-md-2">Contraseña nueva</label>
                        <input name="ClaveNueva" type="password" className="form-control form-control-sm col-md-4" />
                    </div>
                </div>
                <div class="form-group">
                    <div className="form-row">
                        <label class="col-md-2">Confirmar contraseña</label>
                        <input name="ClaveConfirmacion" type="password" className="form-control form-control-sm col-md-4" />
                    </div>
                </div>
            </div>
        );
    }
}

